interface StepOneContent {
  title: string;
  description: string;
  inputs: {
    name: {
      label: string;
      placeholder: string;
      error: string;
    };
    email: {
      label: string;
      placeholder: string;
      errors: {
        required: string;
        invalid: string;
      };
    };
    phone: {
      label: string;
      placeholder: string;
      errors: {
        required: string;
        invalid: string;
      };
    };
    company: {
      label: string;
      optional: string;
      placeholder: string;
    };
  };
}

export const stepOneContent: StepOneContent = {
  title: "Vamos prosseguir com o pedido de orçamento",
  description: "Preencha corretamente com suas informações para podermos entrar em contato e enviar os dados necessários para finalização do pedido.",
  inputs: {
    name: {
      label: "Nome",
      placeholder: "Digite seu nome completo",
      error: "Campo obrigatório"
    },
    email: {
      label: "E-mail",
      placeholder: "Digite seu e-mail",
      errors: {
        required: "Campo obrigatório",
        invalid: "E-mail inválido"
      }
    },
    phone: {
      label: "Telefone",
      placeholder: "(00) 00000-0000",
      errors: {
        required: "Campo obrigatório",
        invalid: "Telefone inválido"
      }
    },
    company: {
      label: "Empresa",
      optional: "(opcional)",
      placeholder: "Nome da sua empresa"
    }
  }
}; 